import { positions, transitions } from 'react-alert'

export default {
  position: positions.TOP_RIGHT,
  timeout: 3000,
  offset: '20px',
  transition: transitions.FADE,
}
